import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { switchTokenValidation } from "../../redux/slices/auth-slice";

export const SessionLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const { isSession } = useSelector(
      (state) => state.authReducer
    );
  
  // If using query params
  // If using route params (e.g., /switch/:token)
  const { token } = useParams();
    useEffect(() => {
      if (isSession) {
        navigate("/");
      }
    }, [isSession]);

  useEffect(() => {
    // dispatch(setLoadingState(true));
    if (!token) {
      navigate("/login");
      return;
    }
      dispatch(switchTokenValidation({ token }));
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <div className="lg:w-2/5 w-full flex flex-col items-center justify-center p-6 lg:p-12 bg-white">
        <div>
          <h4 className="text-xl font-semibold">
            Please wait, switching application...
          </h4>
        </div>
      </div>
    </div>
  );
};
